/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClassifierResponse,
  CreateClassifierRequest,
  HTTPValidationError,
  UpdateClassifierRequest,
} from '../models/index';
import {
    ClassifierResponseFromJSON,
    ClassifierResponseToJSON,
    CreateClassifierRequestFromJSON,
    CreateClassifierRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    UpdateClassifierRequestFromJSON,
    UpdateClassifierRequestToJSON,
} from '../models/index';

export interface CreateClassifierApiClassifiersPostRequest {
    createClassifierRequest: CreateClassifierRequest;
    xApiKey?: string | null;
}

export interface DeleteClassifierApiClassifiersClassifierIdDeleteRequest {
    classifierId: number;
    xApiKey?: string | null;
}

export interface GetClassifierApiClassifiersClassifierIdGetRequest {
    classifierId: number;
    xApiKey?: string | null;
}

export interface GetClassifierTypesApiClassifiersTypesGetRequest {
    xApiKey?: string | null;
}

export interface GetClassifiersApiClassifiersGetRequest {
    xApiKey?: string | null;
}

export interface UpdateClassifierApiClassifiersClassifierIdPutRequest {
    classifierId: number;
    updateClassifierRequest: UpdateClassifierRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class ClassifiersApi extends runtime.BaseAPI {

    /**
     * Create a new classifier
     * Create Classifier
     */
    async createClassifierApiClassifiersPostRaw(requestParameters: CreateClassifierApiClassifiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassifierResponse>> {
        if (requestParameters['createClassifierRequest'] == null) {
            throw new runtime.RequiredError(
                'createClassifierRequest',
                'Required parameter "createClassifierRequest" was null or undefined when calling createClassifierApiClassifiersPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClassifierRequestToJSON(requestParameters['createClassifierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassifierResponseFromJSON(jsonValue));
    }

    /**
     * Create a new classifier
     * Create Classifier
     */
    async createClassifierApiClassifiersPost(requestParameters: CreateClassifierApiClassifiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassifierResponse> {
        const response = await this.createClassifierApiClassifiersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a classifier
     * Delete Classifier
     */
    async deleteClassifierApiClassifiersClassifierIdDeleteRaw(requestParameters: DeleteClassifierApiClassifiersClassifierIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['classifierId'] == null) {
            throw new runtime.RequiredError(
                'classifierId',
                'Required parameter "classifierId" was null or undefined when calling deleteClassifierApiClassifiersClassifierIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers/{classifier_id}`;
        urlPath = urlPath.replace(`{${"classifier_id"}}`, encodeURIComponent(String(requestParameters['classifierId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a classifier
     * Delete Classifier
     */
    async deleteClassifierApiClassifiersClassifierIdDelete(requestParameters: DeleteClassifierApiClassifiersClassifierIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteClassifierApiClassifiersClassifierIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific classifier by ID
     * Get Classifier
     */
    async getClassifierApiClassifiersClassifierIdGetRaw(requestParameters: GetClassifierApiClassifiersClassifierIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassifierResponse>> {
        if (requestParameters['classifierId'] == null) {
            throw new runtime.RequiredError(
                'classifierId',
                'Required parameter "classifierId" was null or undefined when calling getClassifierApiClassifiersClassifierIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers/{classifier_id}`;
        urlPath = urlPath.replace(`{${"classifier_id"}}`, encodeURIComponent(String(requestParameters['classifierId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassifierResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific classifier by ID
     * Get Classifier
     */
    async getClassifierApiClassifiersClassifierIdGet(requestParameters: GetClassifierApiClassifiersClassifierIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassifierResponse> {
        const response = await this.getClassifierApiClassifiersClassifierIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available classifier types
     * Get Classifier Types
     */
    async getClassifierTypesApiClassifiersTypesGetRaw(requestParameters: GetClassifierTypesApiClassifiersTypesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string | null>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers/types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all available classifier types
     * Get Classifier Types
     */
    async getClassifierTypesApiClassifiersTypesGet(requestParameters: GetClassifierTypesApiClassifiersTypesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string | null>> {
        const response = await this.getClassifierTypesApiClassifiersTypesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all classifiers
     * Get Classifiers
     */
    async getClassifiersApiClassifiersGetRaw(requestParameters: GetClassifiersApiClassifiersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClassifierResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClassifierResponseFromJSON));
    }

    /**
     * Get all classifiers
     * Get Classifiers
     */
    async getClassifiersApiClassifiersGet(requestParameters: GetClassifiersApiClassifiersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClassifierResponse>> {
        const response = await this.getClassifiersApiClassifiersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing classifier
     * Update Classifier
     */
    async updateClassifierApiClassifiersClassifierIdPutRaw(requestParameters: UpdateClassifierApiClassifiersClassifierIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassifierResponse>> {
        if (requestParameters['classifierId'] == null) {
            throw new runtime.RequiredError(
                'classifierId',
                'Required parameter "classifierId" was null or undefined when calling updateClassifierApiClassifiersClassifierIdPut().'
            );
        }

        if (requestParameters['updateClassifierRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClassifierRequest',
                'Required parameter "updateClassifierRequest" was null or undefined when calling updateClassifierApiClassifiersClassifierIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/classifiers/{classifier_id}`;
        urlPath = urlPath.replace(`{${"classifier_id"}}`, encodeURIComponent(String(requestParameters['classifierId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClassifierRequestToJSON(requestParameters['updateClassifierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassifierResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing classifier
     * Update Classifier
     */
    async updateClassifierApiClassifiersClassifierIdPut(requestParameters: UpdateClassifierApiClassifiersClassifierIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassifierResponse> {
        const response = await this.updateClassifierApiClassifiersClassifierIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
